import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioFacturacionService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getEstructuraRibisoft(reporte: ReporteRibisoftEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'reportes-facturacion/estructura-ribisoft',
        [
          reporte.codigo,
          {
            'sedes' : reporte.sedes,
            'inicio' : reporte.inicio,
            'fin' : reporte.fin,
            'identificador' : reporte.identificador
          }
        ]
      );
      return response;
    } catch (e) {
      console.error('ServicioFacturacionService.getEstructuraRibisoft()', e);
    }
  }

}

export class ReporteRibisoftEntity {
  codigo: string;
  inicio: number;
  fin: number;
  identificador: number;
  sede ?: number;
  sedes ?: string;
}

export class ReporteRibisoftDataEntity {
  numero: string;
  tipoCliente: string;
  tipoDocumento: string;
  nitCliente: string;
  razonSocialCliente: string;
  nombre1: string;
  nombre2: string;
  apellido1: string;
  apellido2: string;
  emailCliente: string;
  telefonoCliente: string;
  direccionCliente: string;
  observaciones: string;
  fechaCreacion: number;
  fechaVencimiento: number;
  porcentajeFuente: number;
  retefuente: number;
  subtotal: number;
  total: number;
  totalItems: number;
  valorDescuento: number;
  valorImpoconsumo: number;
  valorIva: number;
  reteiva: number;
  reteica: number;
  trm: number;
  resolucion: string;
  prefijo: string;
  referencia: number;
  descripcion: string;
  cantidad: number;
  valor: number;
  descuento: number;
  iva: number;
  anticipo: number;
}

